/* unplugin-vue-components disabled */
import $prompts from 'stores/prompts'
import BuilderInputs from 'components/builder/builder-inputs.vue'

const SCHEMA = [
  {
    field: 'title',
    title: 'Prompt name',
    type: 'text',
    maxlength: 256,
    minlength: 2,
    spellcheck: false,
    placeholder: 'Prompt name',
    required: true
  },
  {
    field: 'prompt',
    title: 'Prompt',
    type: 'textarea',
    placeholder: 'Enter a prompt...',
    className: ['prompt-textarea'],
    maxlength: 2048,
    minlength: 2,
    spellcheck: false,
    required: true,
  },
]
export default {
  components: {
    BuilderInputs
  },
  provide() {
    return {
      store: this.fields,
    }
  },
  emits: ['create', 'cancel'],
  data(){
    return {
      loading: false,
      prompt_id: undefined,
      schema: SCHEMA,
      prev_title: '',
      prev_prompt: '',
      fields: {
        title: '',
        prompt: ''
      },
      valid: true
    }
  },
  computed: {
    edit_mode() {
      return this.prompt_id
    },
    can_save() {
      if (!this.edit_mode) return this.valid
      const diff = this.fields.title !== this.prev_title || this.fields.prompt !== this.prev_prompt
      return this.valid && diff
    }
  },
  methods: {
    open(data = {}) {
      this.prompt_id = data.id
      this.prev_prompt = data.prompt || ''
      this.prev_title = data.title || ''
    
      this.fields.title = this.prev_title
      this.fields.prompt = this.prev_prompt
      this.$refs.modal.open()
    },
    close() {
      this.$refs.modal.close()
    },
    onCancel() {
      this.close()
      this.$emit('cancel')
    },
    async savePrompt() {
      this.loading = true
      if (this.edit_mode) {
        const to_update = {
          title: this.fields.title,
          prompt: this.fields.prompt,
          last_used: new Date().toISOString()
        }
        await $prompts.updatePrompt(this.prompt_id, to_update)
      }
      else await $prompts.savePrompt(this.fields.title, this.fields.prompt)

      this.loading = false
      $utils.toasts.success('Prompt has been saved.', 5000)
      this.close()
      this.$emit('cancel')
    } 
  }
}
